export const SITE_CONFIG = {
  name: 'BastunIT',
  email: 'kontakt@bastunit.pl',
  location: 'Gdańsk, Polska',
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '1x00000000000000000000AA',
} as const;

export const NAVIGATION = {
  problem: { id: 'problem', label: 'Problem' },
  solution: { id: 'solution', label: 'Rozwiązanie' },
  services: { id: 'services', label: 'Usługi' },
  blog: { href: '/blog', label: 'Blog' },
  contact: { id: 'contact', label: 'Kontakt' },
} as const;

export const ARIA_LABELS = {
  mainNav: 'Nawigacja główna',
  homeLink: 'BastunIT - strona główna',
  openMenu: 'Otwórz menu',
  closeMenu: 'Zamknij menu',
  skipToMain: 'Przejdź do głównej treści',
} as const;
